<div class="c-probe-loading-state">
	{{#if loading}}
		<div>
			<i class="fa fa-circle-o-notch fa-spin fa-fw" aria-hidden="true"></i>
			<p>{{loadingText}}</p>
		</div>
	{{elseif error}}
		<div class="has-error">
			<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
			<p>{{errorText}}</p>
		</div>
	{{elseif !hasData}}
		<div>
			<i class="fa fa-search" aria-hidden="true"></i>
			<p>
				{{#if filter}}
					{{noDataFilterText}}
				{{else}}
					{{noDataText}}
				{{/if}}
			</p>
		</div>
	{{/if}}
</div>

<script>
	component.exports = {
		data () {
			return {
				loading: false,
				error: false,
				hasData: true,
				filter: null,
				errorText: 'An unexpected error occurred. Please try again later.',
				loadingText: 'Loading data...',
				noDataFilterText: 'No results found. Please try adjusting the filter.',
				noDataText: 'No results found. Please try again later.',
			};
		},
	};
</script>
